import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, VERSION, ViewChild, forwardRef, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormBuilder, FormGroup, Validators, ReactiveFormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService, NgxSpinnerModule  } from 'ngx-spinner';
import { LocalStorageService } from 'ngx-webstorage';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { DataService } from '../../services/data/data.service';
import { ClaimantService } from '../../services/claimant/claimant.service';
import { Claimant } from '../../models/claimant';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { BsDatepickerConfig, BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { Authenticate } from '../../models/authenticate';


@Component({
  selector: 'app-file',
  templateUrl: './file.html',
  styleUrls: ['./file.css'],
  imports: [ReactiveFormsModule, CommonModule, NgxTrimDirectiveModule, NgxMaskDirective, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule, MatStepperModule, BsDatepickerModule],
  providers: [provideNgxMask()], // Provide at the component level
})
export class File implements OnInit {
  @ViewChild('listofFiles') tableRef: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('stepper') stepper: MatStepper;
  @ViewChild('name') name: ElementRef;

  purchasesDatePickerConfig: Partial<BsDatepickerConfig>;
  distributionsDatePickerConfig: Partial<BsDatepickerConfig>;
  salesDatePickerConfig: Partial<BsDatepickerConfig>;

  clicked: boolean = false;
  submitClicked: boolean = false;
  showMessage: boolean = false;
  submitted: boolean = false;
  isLinear: boolean = false; // Set to true for linear progression
  showDivForNonUS: boolean = false;
  showDivProvince: boolean = false;
  showDivStateZip: boolean = true;
  showSSNTINRow: boolean = false;
  showDivlast4SSN: boolean = false;
  showDivTIN: boolean = false;
  showDivForUS: boolean = false;
  showDivOwnedProperty: boolean = false;
  changed = false;
  stepOneForm: FormGroup;
  stepTwoForm: FormGroup;
  stepThreeForm: FormGroup;
  stepFiveForm: FormGroup;
  stepFourForm: FormGroup;
  claimStartTime: string;
  claimEndTime: string;
  stepSixForm: FormGroup;
  response: string | undefined;
  dateLoaded: Date;
  showDivSubmittalErrorMessage: boolean = false;
  allStates: any = [];
  allCountries: any = [];
  allClaimantAccountTypes: any = [];
  saleList: any = [];
  purchaseList: any = [];
  openingList: any = [];
  lookbackList: any = [];
  closingList: any = [];
  lookbackNoteList: any = [];
  purchaseNoteList: any = [];
  saleNoteList: any = [];
  openingNoteList: any = [];
  closingNoteList: any = [];
  coOwnerNameList: any = [];
  coOwnerSignatureList: any = [];
  showSubmittalErrorWarning: boolean = false;
  distributionList: any = [];
  claimDetailList: any = [];
  supportingDocuments: File[] = [];
  authenticatedUser: Authenticate;
  showDivCoOwners: boolean = false;
  showDivACH: boolean = false;
  showDivOtherDocumentType: boolean = false;
  showDivCityStateZip: boolean = true;
  showDivPaymentEmail: boolean = false;
  showDivNoDocsMessage: boolean = false;
  showDivAgent: boolean = false;

  public claimant: Claimant;
  public errorMessage: string = '';
  public showError: boolean;
  public submittedClaim: Claimant;

  validation_ClassMembersErrorMessage = {
    classMemberName: [
      { type: 'required', message: 'This Field is required' },
      { type: "minlength", message: "Field must be at least 2 characters" },
      { type: "maxlength", message: "Field cannot be more than 50 characters" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
    classMemberFEIN: [
      { type: 'required', message: 'This Field is required' },
      { type: "minlength", message: "Field must be at least 9 characters" },
      { type: "maxlength", message: "Field cannot be more than 9 characters" },
      { type: "pattern", message: "Only use numbers" }
    ],
  };

  validation_ClassMemberPaidAmountsErrorMessage = {
    classMemberName: [
      { type: 'required', message: 'This Field is required' },
      { type: "minlength", message: "Field must be at least 2 characters" },
      { type: "maxlength", message: "Field cannot be more than 50 characters" },
      { type: "pattern", message: "Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)" }
    ],
    classMemberPaidAmount: [
      { type: 'required', message: 'This Field is required' },
      { type: "maxlength", message: "Field cannot be more than 15 digits" },
      { type: "pattern", message: "Only use numbers with optional period (.) and up to 4 digits past decimal" }
    ],
  };

  constructor(private fb: FormBuilder,
    private httpClient: HttpClient,
    private storage: LocalStorageService,
    private dataService: DataService, 
    private router: Router,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef, 
    private claimantService: ClaimantService) { }


  ngOnInit() {
    this.loadAllStates();
    this.loadAllCountries();
    this.loadAllClaimantAccountTypes();
    this.authenticatedUser = this.storage.retrieve('authenticatedUser');
    this.dateLoaded = new Date();
    this.claimStartTime = this.dateLoaded.toLocaleTimeString();

    this.purchasesDatePickerConfig = Object.assign({},
      {
        containerClass: 'theme-dark-blue',
        showWeekNumbers: false,
        minDate: new Date(1900, 0, 0),
        maxDate: new Date(2026, 7, 12),
        dateInputFormat: 'MM/DD/YYYY',
      });
 
    this.salesDatePickerConfig = Object.assign({},
      {
        containerClass: 'theme-dark-blue',
        showWeekNumbers: false,
        minDate: new Date(2021, 11, 2),
        maxDate: new Date(2023, 6, 5),
        dateInputFormat: 'MM/DD/YYYY'
      });

    this.stepOneForm = this.fb.group({
      noticeId: [this.authenticatedUser.noticeId],
      uniqueId: [this.authenticatedUser.uniqueId],
      pin: [this.authenticatedUser.pin],
      pAddress: [this.authenticatedUser.pAddress],
      pCity: [this.authenticatedUser.pCity],
      pState: [this.authenticatedUser.pState],
      pZip: [this.authenticatedUser.pZip],
      cName: [this.authenticatedUser.cName],
      cAddress: [this.authenticatedUser.cAddress],
      cCity: [this.authenticatedUser.cCity],
      cState: [this.authenticatedUser.cState],
      cZip: [this.authenticatedUser.cZip],
      area: [this.authenticatedUser.area],
    });
    this.stepTwoForm = this.fb.group({
      pAddress: [this.authenticatedUser.pAddress],
      pCity: [this.authenticatedUser.pCity],
      pState: [this.authenticatedUser.pState],
      pZip: [this.authenticatedUser.pZip],
      cName: [this.authenticatedUser.cName],
      cAddress: [this.authenticatedUser.cAddress],
      cCity: [this.authenticatedUser.cCity],
      cState: [this.authenticatedUser.cState],
      cZip: [this.authenticatedUser.cZip],
      area: [this.authenticatedUser.area],
      informationUpdated: ['', Validators.compose([Validators.required])],
      updatedContactStreet1: [''],
      updatedContactStreet2: [''],
      updatedContactCity: [''],
      updatedContactState: [''],
      updatedContactCountry: [''],
      updatedContactProvince: [''],
      updatedContactPostalCode: [''],
      updatedContactZip: [''],
      primaryPhone: ['', Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")])],
      primaryPhoneType: ['', Validators.compose([Validators.required])],
      emailAddress: ['', Validators.compose([Validators.required, Validators.maxLength(255), Validators.pattern("[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")])],
      optTINSSN: ['', Validators.compose([Validators.required])],
      sSN: ['', Validators.compose([Validators.required, Validators.maxLength(9), Validators.minLength(9), Validators.pattern("^[0-9]+$")])],
      tin: ['', Validators.compose([Validators.required, Validators.maxLength(9), Validators.minLength(9), Validators.pattern("^[0-9]+$")])],
    });
    this.stepThreeForm = this.fb.group({
      pAddress: [this.authenticatedUser.pAddress],
      pCity: [this.authenticatedUser.pCity],
      pState: [this.authenticatedUser.pState],
      pZip: [this.authenticatedUser.pZip],

      cName: [this.authenticatedUser.cName],
      cAddress: [this.authenticatedUser.cAddress],
      cCity: [this.authenticatedUser.cCity],
      cState: [this.authenticatedUser.cState],
      cZip: [this.authenticatedUser.cZip],
      area: [this.authenticatedUser.area],

      dateTitleAcquired: ['', Validators.compose([Validators.required])],
      didYouOwnPropertyDuringClassPeriod: ['', Validators.compose([Validators.required])],
      doYouCurrentlyOwnTheProperty: ['', Validators.compose([Validators.required])],
      datePropertyWasSoldOrTransferred: [''],
      isThereACoOwner: ['', Validators.compose([Validators.required])],
      coOwnerName: [''],
    });
    this.stepFourForm = this.fb.group({
      areYouAnEmployee: ['', Validators.compose([Validators.required])],
      verifyNonEmployment: [false],
    });
    this.stepFiveForm = this.fb.group({
      documentType: ['', Validators.compose([Validators.required])],
      otherDocumentType: ['']
    });
    this.stepSixForm = this.fb.group({
      signingOnBehalfQuestion: ['', Validators.compose([Validators.required])],
      propertyOwnerSignature: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      signature: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      nameOfPersonSigning: [''],
      helperCapacity: [''],
      // dateTitleAcquired: [''],
      coOwnerSignature: [''],
      googleRecaptchaToken: ['', Validators.compose([Validators.required])],
      noticeId: [this.authenticatedUser.noticeId],
      uniqueId: [this.authenticatedUser.uniqueId],
      pin: [this.authenticatedUser.pin],
    }),
    this.stepSixForm.patchValue({
      noticeId: this.authenticatedUser.noticeId,
      uniqueId: this.authenticatedUser.uniqueId,
      pin: this.authenticatedUser.pin,
      // dateTitleAcquired: this.stepThreeData.dateTitleAcquired,

    });
  }
  

  getInformationUpdatedValue($event) {
    const isChecked = $event.target.checked;



    if ($event.target.value === 'Yes') {
      // Do something when checkbox is checked
      this.showDivPaymentEmail = true;

      this.stepTwoForm.get('updatedContactStreet1').enable();
      this.stepTwoForm.get('updatedContactStreet2').enable();
      this.stepTwoForm.get('updatedContactCity').enable();
      this.stepTwoForm.get('updatedContactState').enable();
      this.stepTwoForm.get('updatedContactCountry').enable();
      this.stepTwoForm.get('updatedContactProvince').enable();
      this.stepTwoForm.get('updatedContactZip').enable();
      this.stepTwoForm.get('updatedContactPostalCode').enable();

      this.changed = false;
      this.stepTwoForm.get('updatedContactStreet1').setValidators(Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepTwoForm.get('updatedContactStreet1').updateValueAndValidity();

      this.stepTwoForm.get('updatedContactStreet2').setValidators(Validators.compose([Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepTwoForm.get('updatedContactStreet2').updateValueAndValidity();

      this.stepTwoForm.get('updatedContactCity').setValidators(Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepTwoForm.get('updatedContactCity').updateValueAndValidity();

      this.stepTwoForm.get('updatedContactState').setValidators(Validators.compose([Validators.required]));
      this.stepTwoForm.get('updatedContactState').updateValueAndValidity();

      this.stepTwoForm.get('updatedContactCountry').setValidators(Validators.compose([Validators.required]));
      this.stepTwoForm.get('updatedContactCountry').updateValueAndValidity();

      this.stepTwoForm.get('updatedContactProvince').setValidators(Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepTwoForm.get('updatedContactProvince').updateValueAndValidity();

      this.stepTwoForm.get('updatedContactZip').setValidators(Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")]));
      this.stepTwoForm.get('updatedContactZip').updateValueAndValidity();

      this.stepTwoForm.get('updatedContactPostalCode').setValidators(Validators.compose([Validators.maxLength(10)]));
      this.stepTwoForm.get('updatedContactPostalCode').updateValueAndValidity();
    }

    if ($event.target.value === 'No') {
      // Do something when checkbox is unchecked
      this.showDivPaymentEmail = false;

      this.stepTwoForm.get('updatedContactStreet1').disable();
      this.stepTwoForm.get('updatedContactStreet2').disable();
      this.stepTwoForm.get('updatedContactCity').disable();
      this.stepTwoForm.get('updatedContactState').disable();
      this.stepTwoForm.get('updatedContactCountry').disable();
      this.stepTwoForm.get('updatedContactProvince').disable();
      this.stepTwoForm.get('updatedContactZip').disable();
      this.stepTwoForm.get('updatedContactPostalCode').disable();

      this.stepTwoForm.get('updatedContactStreet1').reset();
      this.stepTwoForm.get('updatedContactStreet1').clearValidators();
      this.stepTwoForm.get('updatedContactStreet1').updateValueAndValidity();

      this.stepTwoForm.get('updatedContactStreet2').reset();
      this.stepTwoForm.get('updatedContactStreet2').clearValidators();
      this.stepTwoForm.get('updatedContactStreet2').updateValueAndValidity();

      this.stepTwoForm.get('updatedContactCity').reset();
      this.stepTwoForm.get('updatedContactCity').clearValidators();
      this.stepTwoForm.get('updatedContactCity').updateValueAndValidity();

      this.stepTwoForm.get('updatedContactState').reset();
      this.stepTwoForm.get('updatedContactState').clearValidators();
      this.stepTwoForm.get('updatedContactState').updateValueAndValidity();

      this.stepTwoForm.get('updatedContactCountry').reset();
      this.stepTwoForm.get('updatedContactCountry').clearValidators();
      this.stepTwoForm.get('updatedContactCountry').updateValueAndValidity();

      this.stepTwoForm.get('updatedContactProvince').reset();
      this.stepTwoForm.get('updatedContactProvince').clearValidators();
      this.stepTwoForm.get('updatedContactProvince').updateValueAndValidity();

      this.stepTwoForm.get('updatedContactZip').reset();
      this.stepTwoForm.get('updatedContactZip').clearValidators();
      this.stepTwoForm.get('updatedContactZip').updateValueAndValidity();

      this.stepTwoForm.get('updatedContactPostalCode').reset();
      this.stepTwoForm.get('updatedContactPostalCode').clearValidators();
      this.stepTwoForm.get('updatedContactPostalCode').updateValueAndValidity();
    }

  }

  getAgentValue($event) {
    const isChecked = $event.target.checked;



    if ($event.target.value === 'Yes') {
      // Do something when checkbox is checked
      this.showDivAgent = true;

      this.stepSixForm.get('nameOfPersonSigning').enable();
      this.stepSixForm.get('helperCapacity').enable();
      this.stepSixForm.get('signature').enable();


      this.changed = false;
      this.stepSixForm.get('nameOfPersonSigning').setValidators(Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepSixForm.get('nameOfPersonSigning').updateValueAndValidity();

      this.stepSixForm.get('helperCapacity').setValidators(Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepSixForm.get('helperCapacity').updateValueAndValidity();

      this.stepSixForm.get('signature').setValidators(Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepSixForm.get('signature').updateValueAndValidity();
    }

    if ($event.target.value === 'No') {
      // Do something when checkbox is unchecked
      this.showDivAgent = false;

      this.stepSixForm.get('nameOfPersonSigning').disable();
      this.stepSixForm.get('helperCapacity').disable();
      this.stepSixForm.get('signature').disable();

      this.stepSixForm.get('nameOfPersonSigning').reset();
      this.stepSixForm.get('nameOfPersonSigning').clearValidators();
      this.stepSixForm.get('nameOfPersonSigning').updateValueAndValidity();

      this.stepSixForm.get('helperCapacity').reset();
      this.stepSixForm.get('helperCapacity').clearValidators();
      this.stepSixForm.get('helperCapacity').updateValueAndValidity();

      this.stepSixForm.get('signature').reset();
      this.stepSixForm.get('signature').clearValidators();
      this.stepSixForm.get('signature').updateValueAndValidity();
    }

  }

  getClaimantAccounTypeValue($event) {
    // Access the event source and value.
    if ($event.target.value === 'Other') {
      this.showDivOtherDocumentType = true;
      this.stepFiveForm.get('otherDocumentType').setValidators(Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
    }

    if ($event.target.value !== 'Other') {
      this.showDivOtherDocumentType = false;
      this.stepFiveForm.get('otherDocumentType').clearValidators();
      this.stepFiveForm.get('otherDocumentType').updateValueAndValidity();
      this.stepFiveForm.get('otherDocumentType').reset();
    }
  }

  getPaymentRadioValue($event) {
    // if you need the event source and value it can be accessed.
    if ($event.target.value === 'Yes') {
      this.showDivACH = false;

      this.stepFourForm.get('verifyNonEmployment').setValue(false);
      this.stepFourForm.get('verifyNonEmployment').clearValidators();
      this.stepFourForm.get('verifyNonEmployment').updateValueAndValidity();
    }
    if ($event.target.value === 'No') {
      this.showDivACH = true;

      this.stepFourForm.get('verifyNonEmployment').setValue(false);
      this.stepFourForm.get('verifyNonEmployment').setValidators(Validators.compose([Validators.requiredTrue]));
      this.stepFourForm.get('verifyNonEmployment').updateValueAndValidity();
    }
  }



  getCoOwnerValue($event) {
    // Access the event source and value.
    if ($event.target.value === 'Yes') {
      this.showDivCoOwners = true;
    } else {
      this.showDivCoOwners = false;
      this.coOwnerNameList = [];

      // Clear any leftover Co-Owner's Name value/validators and the warning message
      // so switching from Yes to No no longer blocks moving to the Next page.
      const coOwnerNameControl = this.stepThreeForm.get('coOwnerName');
      coOwnerNameControl.setValue('');
      coOwnerNameControl.clearValidators();
      coOwnerNameControl.updateValueAndValidity();
      coOwnerNameControl.markAsUntouched();
      coOwnerNameControl.markAsPristine();

      this.showMessage = false;
    }
  }


  getOwnedPropertyValue($event) {
    // Access the event source and value.
    if ($event.target.value === 'No') {
      this.showDivOwnedProperty = true;
      this.stepThreeForm.get('datePropertyWasSoldOrTransferred').setValidators(Validators.compose([Validators.required]));
    }

    if ($event.target.value !== 'No') {
      this.showDivOwnedProperty = false;
      this.stepThreeForm.get('datePropertyWasSoldOrTransferred').clearValidators();
      this.stepThreeForm.get('datePropertyWasSoldOrTransferred').updateValueAndValidity();
      this.stepThreeForm.get('datePropertyWasSoldOrTransferred').reset();
    }
  }

  loadAllStates() {
    this.httpClient.get("assets/States.json").subscribe(data => {
      this.allStates = data;
    })
  }

  loadAllCountries() {
    this.httpClient.get("assets/Countries.json").subscribe(data => {
      this.allCountries = data;
    })
  }

  loadAllClaimantAccountTypes() {
    this.httpClient.get("assets/ClaimantAccountTypes.json").subscribe(data => {
      this.allClaimantAccountTypes = data;
    })
  }

  resolved(captchaResponse: string) {
    this.response = captchaResponse;
  }

  // convenience getter for easy access to form fields

  get e() { return this.stepOneForm.controls; }
  get f() { return this.stepTwoForm.controls; }
  get g() { return this.stepThreeForm.controls; }
  get h() { return this.stepFourForm.controls; }
  get i() { return this.stepFiveForm.controls; }
  get j() { return this.stepSixForm.controls; }


  done() {
    this.stepper.selected.completed = false;
    this.stepper.selected.editable = true;
    this.stepper.next();
    this.submitted = false;
  }

  edit() {
    this.stepper.selected.completed = false;
    this.stepper.selected.editable = true;
    this.stepper.previous();
  }

  saveAndValidateStepTwo() {
    // stop here if form is invalid
    if (this.stepTwoForm.invalid) {
      return;
    }


    //this.stepper.selected.completed = false;
    //this.stepper.selected.editable = true;  
    /*this.submitted = false;*/
    let test = this.stepTwoForm.value;
    this.dataService.stepTwoSharedData = test;
    this.stepper.next();
  }

  saveAndValidateStepThree() {

    const dateTitleAcquiredValue = this.stepThreeForm.get('dateTitleAcquired').value;
    if (dateTitleAcquiredValue instanceof Date) {
      this.stepThreeForm.get('dateTitleAcquired').setValue(dateTitleAcquiredValue.toLocaleDateString("en-us"));
    }

    const datePropertyWasSoldOrTransferredValue = this.stepThreeForm.get('datePropertyWasSoldOrTransferred').value;
    if (datePropertyWasSoldOrTransferredValue instanceof Date) {
      this.stepThreeForm.get('datePropertyWasSoldOrTransferred').setValue(datePropertyWasSoldOrTransferredValue.toLocaleDateString("en-us"));
    }

    // stop here if form is invalid
    if (this.stepThreeForm.invalid) {
      return;
    }

    const coOwnerNameControl = this.stepThreeForm.get('coOwnerName');
    // Read the raw, untrimmed value in case the trim directive hasn't finished
    // re-syncing the control on blur yet (e.g. clicking Next while still focused in the field).
    const rawValue = (coOwnerNameControl.value ?? '').toString().trim();

    if (rawValue !== '') {
      coOwnerNameControl.setValue(rawValue);
      this.showMessage = true;
      return;
    }

    this.showMessage = false;

    // Require at least one co-owner entry when the user indicated there is a co-owner
    if (this.stepThreeForm.get('isThereACoOwner').value === 'Yes' && this.coOwnerNameList.length === 0) {
      // Surface "This field is required" under the Co-Owner's Name field
      coOwnerNameControl.setValidators([Validators.required]);
      coOwnerNameControl.updateValueAndValidity();
      coOwnerNameControl.markAsTouched();
      coOwnerNameControl.markAsDirty();

      this.showMessage = true;
      return;
    }

    this.dataService.stepThreeSharedDataCoOwnerNames = this.coOwnerNameList;
    let test = this.stepThreeForm.value;
    this.dataService.stepThreeSharedData = test;
    this.stepper.next();
  }



  saveAndValidateStepFour() {
    // stop here if form is invalid
    if (this.stepFourForm.invalid) {
      return;
    }

    let test = this.stepFourForm.value;
    this.dataService.stepFourSharedData = test;

    this.stepper.next();
  }

  saveAndValidateStepFive() {
    // stop here if form is invalid
    if (this.stepFiveForm.invalid) {
      
      return;
      
    }

    this.dataService.stepFiveSharedDataDocuments = this.supportingDocuments;
    this.dataService.stepFiveSharedData = this.stepFiveForm.value;
    this.stepper.next();
  }

    

  getPhoneType2Value() {
    this.changed = true;
    const secondaryPhoneType = this.stepTwoForm.get('secondaryPhoneType')?.value;

    if (secondaryPhoneType !== '') {
      this.stepTwoForm.get('secondaryPhone').setValidators(Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")]));
    } else {
      this.stepTwoForm.get('secondaryPhone').clearValidators();
    }
    this.stepTwoForm.get('secondaryPhone').updateValueAndValidity();
  }


  getCountryValue($event) {
    // if you need the event source and value it can be accessed.
    if ($event.target.value !== 'United States') {
      this.showDivForNonUS = true;
      this.showDivForUS = false;
      //this.showDivStateZip = false;
      this.showSSNTINRow = false;

      this.stepTwoForm.get('updatedContactState').clearValidators();
      this.stepTwoForm.get('updatedContactState').updateValueAndValidity();
      this.stepTwoForm.get('updatedContactState').reset();
      this.stepTwoForm.get('updatedContactZip').clearValidators();
      this.stepTwoForm.get('updatedContactZip').updateValueAndValidity();
      this.stepTwoForm.get('updatedContactZip').reset();
      this.stepTwoForm.get('updatedContactCity').reset();
      this.stepTwoForm.get('updatedContactPostalCode').setValidators(Validators.compose([Validators.maxLength(10)]));
      this.stepTwoForm.get('updatedContactProvince').setValidators(Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
    }

    if ($event.target.value === 'United States') {
      this.showDivForUS = true;
      this.showDivForNonUS = false;

      this.showSSNTINRow = true;
      this.stepTwoForm.get('updatedContactCity').reset();
      this.stepTwoForm.get('updatedContactProvince').reset();
      this.stepTwoForm.get('updatedContactPostalCode').reset();

      this.stepTwoForm.get('updatedContactProvince').clearValidators();
      this.stepTwoForm.get('updatedContactProvince').updateValueAndValidity();
      this.stepTwoForm.get('updatedContactPostalCode').clearValidators();
      this.stepTwoForm.get('updatedContactPostalCode').updateValueAndValidity();

      this.stepTwoForm.get('updatedContactCity').setValidators(Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]));
      this.stepTwoForm.get('updatedContactState').setValidators(Validators.compose([Validators.required]));
      this.stepTwoForm.get('updatedContactZip').setValidators(Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")]));

    }
  }

  getOptTINSSNValue($event) {
    // Access the event source and value.
    if ($event.target.value === 'Last Four Of SSN') {
      this.showDivlast4SSN = true;
      this.showDivTIN = false;
      this.stepTwoForm.get('sSN').setValidators(Validators.compose([Validators.required, Validators.maxLength(9), Validators.minLength(9), Validators.pattern("^[0-9]+$")]));
      this.stepTwoForm.get('tin').clearValidators();
      this.stepTwoForm.get('tin').updateValueAndValidity();
      this.stepTwoForm.get('tin').reset();
    }

    if ($event.target.value === 'Tax Identification Number') {
      this.showDivTIN = true;
      this.showDivlast4SSN = false;
      this.stepTwoForm.get('tin').setValidators(Validators.compose([Validators.required, Validators.maxLength(9), Validators.minLength(9), Validators.pattern("^[0-9]+$")]));
      this.stepTwoForm.get('sSN').clearValidators();
      this.stepTwoForm.get('sSN').updateValueAndValidity();
      this.stepTwoForm.get('sSN').reset();
    }
  }

  onBlur(event) {
    if (event.target.value !== '')
      event.target.value = parseFloat(event.target.value).toFixed(2)
  }

  // Remove the second element and so on
  removeAllExceptFirst(formArray: FormArray): void {
    while (formArray.length > 1) {
      formArray.removeAt(0);
    }
  }

  removeTable() {
    if (this.tableRef) {
      this.tableRef.nativeElement.remove();
    }
  }

  clearCoOwnerSignatureData() {
    this.stepSixForm.get('coOwnerSignature').setValue('');
    this.stepSixForm.get('coOwnerSignature').clearValidators();
    this.stepSixForm.get('coOwnerSignature').updateValueAndValidity();
    this.stepSixForm.get('coOwnerSignature').markAsUntouched();
    this.stepSixForm.get('coOwnerSignature').markAsPristine();

    this.showMessage = false;
  }

  clearCoOwnerData() {
    this.stepThreeForm.get('coOwnerName').setValue('');
    this.stepThreeForm.get('coOwnerName').clearValidators();
    this.stepThreeForm.get('coOwnerName').updateValueAndValidity();
    this.stepThreeForm.get('coOwnerName').markAsUntouched();
    this.stepThreeForm.get('coOwnerName').markAsPristine();

    this.showMessage = false;
  }

  clearSalesData() {
    this.stepThreeForm.get('salesQuantity').setValue('');
    this.stepThreeForm.get('salesQuantity').clearValidators();
    this.stepThreeForm.get('salesQuantity').updateValueAndValidity();
    this.stepThreeForm.get('salesQuantity').markAsUntouched();
    this.stepThreeForm.get('salesQuantity').markAsPristine();

    this.stepThreeForm.get('salesTotalPrice').setValue('');
    this.stepThreeForm.get('salesTotalPrice').clearValidators();
    this.stepThreeForm.get('salesTotalPrice').updateValueAndValidity();
    this.stepThreeForm.get('salesTotalPrice').markAsUntouched();
    this.stepThreeForm.get('salesTotalPrice').markAsPristine();

    this.stepThreeForm.get('salesPricePerShare').setValue('');
    this.stepThreeForm.get('salesPricePerShare').clearValidators();
    this.stepThreeForm.get('salesPricePerShare').updateValueAndValidity();
    this.stepThreeForm.get('salesPricePerShare').markAsUntouched();
    this.stepThreeForm.get('salesPricePerShare').markAsPristine();

    this.stepThreeForm.get('salesTradeDate').setValue('');
    this.stepThreeForm.get('salesTradeDate').clearValidators();
    this.stepThreeForm.get('salesTradeDate').updateValueAndValidity();
    this.stepThreeForm.get('salesTradeDate').markAsUntouched();
    this.stepThreeForm.get('salesTradeDate').markAsPristine();

    this.stepThreeForm.get('salesHasProof').setValue(false);

    this.showMessage = false;

  }

  addCoOwnerData() {
    this.clicked = true;

    this.stepThreeForm.get('coOwnerName')?.setValidators([Validators.required, Validators.minLength(2), Validators.maxLength(50), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]);
    this.stepThreeForm.get('coOwnerName')?.updateValueAndValidity();

    if (this.stepThreeForm.get('coOwnerName').invalid) {
      this.clicked = false;
      return;
    }

    let nL = new Array();

    nL = [{
      CoOwnerName: this.stepThreeForm.get('coOwnerName').value
    }];

    for (let i = 0; i < nL.length; i++) {
      this.coOwnerNameList.push(nL[i]);
    }

    this.stepThreeForm.get('coOwnerName').setValue('');
    this.stepThreeForm.get('coOwnerName').clearValidators();
    this.stepThreeForm.get('coOwnerName').updateValueAndValidity();
    this.stepThreeForm.get('coOwnerName').markAsUntouched();
    this.stepThreeForm.get('coOwnerName').markAsPristine();

    this.showMessage = false;
    this.clicked = false;
  }

  removecoOwnerSignaturesRow(i: number) {
    this.coOwnerSignatureList.splice(i, 1);
  }

  addCoOwnerSignatureData() {
    this.clicked = true;

    this.stepSixForm.get('coOwnerSignature')?.setValidators([Validators.required, Validators.minLength(2), Validators.maxLength(50), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")]);
    this.stepSixForm.get('coOwnerSignature')?.updateValueAndValidity();

    if (this.stepSixForm.get('coOwnerSignature').invalid) {
      return;
    }

    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    };

    let sL = new Array();

    sL = [{
      CoOwnerSignature: this.stepSixForm.get('coOwnerSignature').value
    }];

    for (let i = 0; i < sL.length; i++) {
      this.coOwnerSignatureList.push(sL[i]);
    }

    this.stepSixForm.get('coOwnerSignature').setValue('');
    this.stepSixForm.get('coOwnerSignature').clearValidators();
    this.stepSixForm.get('coOwnerSignature').updateValueAndValidity();
    this.stepSixForm.get('coOwnerSignature').markAsUntouched();
    this.stepSixForm.get('coOwnerSignature').markAsPristine();

    this.showMessage = false;
    this.clicked = false;


    /* (<FormArray>this.stepThreeForm.get('purchases')).push(this.newPurchase());*/
  }

  removecoOwnerNamesRow(i: number) {
    this.coOwnerNameList.splice(i, 1);
  }

  removePurchasesRow(i: number) {
    this.purchaseList.splice(i, 1);
  }

  removeSalesRow(i: number) {
    this.saleList.splice(i, 1);
  }

  getFileDetails(e) {

    for (let i = 0; i < e.target.files.length; i++) {
      this.supportingDocuments.push(e.target.files[i]);
    }
  
  }

  removeRow(i: number) {
    this.supportingDocuments.splice(i, 1);
    this.fileInput.nativeElement.value = null;
  }
  get stepOneData(): any {
    return this.dataService.stepOneSharedData;
  }
  get stepTwoData(): any {
    return this.dataService.stepTwoSharedData;
  }
  get stepThreeData(): any {
    return this.dataService.stepThreeSharedData;
  }
  get stepThreeDataCoOwnerNames(): any {
    return this.dataService.stepThreeSharedDataCoOwnerNames;
  }
  
  get stepFourData(): any {
    return this.dataService.stepFourSharedData;
  }
  get stepFiveData(): any {
    return this.dataService.stepFiveSharedData;
  }
  get stepFiveDataDocuments(): any {
    return this.dataService.stepFiveSharedDataDocuments;
  }
  get stepSixData(): any {
    return this.dataService.stepSixSharedData;
  }
  get stepSixDataCoOwnerSignatures(): any {
    return this.dataService.stepSixSharedDataCoOwnerSignatures;
  }

 


  buildClaimDetailList(newList: any) {
    for (let i = 0; i < newList.length; i++) {
      this.claimDetailList.push(newList[i]);
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.stepSixForm.invalid) {
      return;
    }

    const unsavedCoOwnerSignature = this.stepSixForm.get('coOwnerSignature').value;
    if (unsavedCoOwnerSignature !== '' && unsavedCoOwnerSignature != null) {
      this.showMessage = true;
      return;
    }

    this.submitClicked = true;
    this.clicked = true;
    const claimant = this.stepSixForm.value;
    this.dateLoaded = new Date();
    this.claimEndTime = this.dateLoaded.toLocaleTimeString();
    this.dataService.stepSixSharedDataCoOwnerSignatures = this.coOwnerSignatureList;
    this.buildClaimDetailList(this.stepThreeDataCoOwnerNames);
    this.buildClaimDetailList(this.stepSixDataCoOwnerSignatures);

    claimant.informationUpdated = this.stepTwoData.informationUpdated;
    claimant.updatedContactStreet1 = this.stepTwoData.updatedContactStreet1;
    claimant.updatedContactStreet2 = this.stepTwoData.updatedContactStreet2;
    claimant.updatedContactCity = this.stepTwoData.updatedContactCity;
    claimant.updatedContactState = this.stepTwoData.updatedContactState;
    claimant.updatedContactCountry = this.stepTwoData.updatedContactCountry;
    claimant.updatedContactProvince = this.stepTwoData.updatedContactProvince;
    claimant.updatedContactPostalCode = this.stepTwoData.updatedContactPostalCode;
    claimant.updatedContactZip = this.stepTwoData.updatedContactZip;
    claimant.primaryPhone = this.stepTwoData.primaryPhone;
    claimant.primaryPhoneType = this.stepTwoData.primaryPhoneType;
    claimant.emailAddress = this.stepTwoData.emailAddress;
    claimant.sSN = this.stepTwoData.sSN;
    claimant.tin = this.stepTwoData.tin;

    

    claimant.dateTitleAcquired = this.stepThreeData.dateTitleAcquired;
    claimant.didYouOwnPropertyDuringClassPeriod = this.stepThreeData.didYouOwnPropertyDuringClassPeriod;
    claimant.datePropertyWasSoldOrTransferred = this.stepThreeData.datePropertyWasSoldOrTransferred;
    claimant.doYouCurrentlyOwnTheProperty = this.stepThreeData.doYouCurrentlyOwnTheProperty;
    claimant.isThereACoOwner = this.stepThreeData.isThereACoOwner;

    claimant.areYouAnEmployee = this.stepFourData.areYouAnEmployee;
    claimant.verifyNonEmployment = this.stepFourData.verifyNonEmployment;

    claimant.documentType = this.stepFiveData.documentType;
    claimant.otherDocumentType = this.stepFiveData.otherDocumentType;



    claimant.propertyOwnerSignature = this.stepSixForm.get('propertyOwnerSignature').value;
    claimant.nameOfPersonSigning = this.stepSixForm.get('nameOfPersonSigning').value;
    claimant.helperCapacity = this.stepSixForm.get('helperCapacity').value;
    claimant.signature = this.stepSixForm.get('signature').value;

    claimant.claimDetail = this.claimDetailList;

    claimant.googleRecaptchaToken = this.stepSixForm.get('googleRecaptchaToken').value;
    claimant.noticeId = this.stepSixForm.get('noticeId').value;
    claimant.pin = this.stepSixForm.get('pin').value;
    claimant.uniqueId = this.stepSixForm.get('uniqueId').value;

    claimant.claimStartTime = this.claimStartTime;
    claimant.claimEndTime = this.claimEndTime;

    this.spinner.show();
    this.CreateClaimant(claimant);
  }



  CreateClaimant(claimant: Claimant) {
     this.claimantService.createClaimant(claimant).subscribe(res => {
      this.submittedClaim = res;
      this.SubmitDocuments(this.submittedClaim.claimNumber);
    });
  }

  SubmitDocuments(claimNumber: string) {
    this.claimantService.submitDocuments(this.submittedClaim.claimNumber, this.stepFiveDataDocuments).subscribe(() => {
    });
    this.storage.store('claimant', this.submittedClaim);
    // this.dataSaved = true;
    // this.submitted = false;
    // this.notSubmitted = false;
    // this.message = "Record Saved Successfully";
    this.stepSixForm.reset();
    this.spinner.hide();
    this.router.navigate(['/complete']);
  }
}
